export const SHARE_REGISTER_ACCEPTED = "SHARE_REGISTER_ACCEPTED";
export const SHARE_REGISTER_SNOOZED = "SHARE_REGISTER_SNOOZED";
export const SHARE_REGISTER_REJECTED = "SHARE_REGISTER_REJECTED";
